import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Fan = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Fan' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z M15,12 C19,15 20,19 20,19 M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,9 C15,4 19,3 19,3 M12,15 C9,19 5,20 5,20 M9,12 C5,9 4,5 4,5' />
  </StyledIcon>
);
